export default __webpack_public_path__ + "static/media/3536 knife block C side.98d0b8d2.png";